import styled from 'styled-components';
import { media } from '@common/theme';
import { TypographySizes } from '@common/theme/theme.types';

interface TypographyGeneratorWrapperProps {
  typographySizes: TypographySizes;
  strong: boolean;
  uppercase: boolean;
  marginBottom: string;
  colour?: string;
  font?: string;
}

export const TypographyGeneratorWrapper = styled.div<TypographyGeneratorWrapperProps>`
  font-family: ${({ theme, font }) => font || theme.bodyFont};
  color: ${({ theme, colour }) => colour || theme.defaultColors.fontPrimary};
  font-size: ${({ typographySizes }) => typographySizes.mobile.fontSize};
  line-height: ${({ typographySizes }) => typographySizes.mobile.lineHeight};
  font-weight: ${({ theme, strong }) =>
    strong ? theme.fontWeights.semiBold : theme.fontWeights.normal};
  text-transform: ${({ uppercase }) => (uppercase ? 'uppercase' : 'initial')};
  margin-top: 0;
  margin-bottom: ${({ marginBottom }) => marginBottom};
  ${media.desktop<TypographyGeneratorWrapperProps>`
    font-size: ${({ typographySizes }) => typographySizes.desktop.fontSize};
    line-height: ${({ typographySizes }) => typographySizes.desktop.lineHeight};
  `}
`;
